import LegalPage from './LegalPage'

export default function Zwroty() {
  return <LegalPage tab="zwroty" />
}
